import { gql, useMutation } from "@apollo/client";

const MUTATION = gql`
  mutation UnblockUser($userId: ID!) {
    unblockUser(userId: $userId) {
      success
    }
  }
`;

interface DataType {
  unblockUser: {
    success: boolean;
  };
}

interface VariablesType {
  userId: string;
}

export default function useUnblockUser() {
  return useMutation<DataType, VariablesType>(MUTATION);
}
